import { useContext, useState } from 'react'

import { Box, Button, Icon, Text } from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'

import { HeaderInformationItem } from '../../../../components/HeaderInformationItem/header-information-item.comp'
import { GlobalDataContext } from '../../../../contexts/globalData'
import { BlockchainTreeModal } from '../../../OriginInvoice/components/BlockchainTreeModal/blockchain-tree-modal.comp'
import { ProductDetailsContext } from '../../product-details.context'
import { ProductItemTraceability } from '../ProductItemTraceability/product-item-traceability.comp'

import * as Styles from './product-item-card.styles'

export const ProductItemCard = () => {
  const [open, setOpen] = useState(false)

  const { selectedItem, itemBlockchainTree } = useContext(ProductDetailsContext)
  const { blockchainNetwork } = useContext(GlobalDataContext)

  const getOrderProductionStatusText = (status?: string | null) => {
    switch (status) {
      case 'pending':
        return 'Em andamento'
      case 'complete':
        return 'Concluído'
      default:
        return '--'
    }
  }

  const navigate = useNavigate()

  return (
    <>
      <Box height="100%" width="100%" direction="column">
        <Styles.HeaderContainer
          width="100%"
          direction="column"
          gap={2}
          padding={2}
        >
          <Box width="100%" gap={1} justifyContent="space-between">
            <Box gap={1} direction="column" flex={1}>
              <Text color="grey_3" size="small">
                Item selecionado
              </Text>
              <Text fontWeight={500} size="small">
                {selectedItem ? selectedItem?.description : 'Selecione um item'}
              </Text>
            </Box>
            <Box>
              {selectedItem && (
                <Button
                  variant="outlined"
                  padding="10px 14px"
                  onClick={() => navigate(`/origins/${selectedItem?.id}`)}
                >
                  <Box gap={1} alignItems="center">
                    <Text color="grey_1" size="small" fontWeight={500}>
                      Editar Rastreabilidade
                    </Text>
                    <Icon name="edit" size={20} color="grey_1" />
                  </Box>
                </Button>
              )}
            </Box>
          </Box>
          <Box width="100%">
            <Box flex={1}>
              <HeaderInformationItem
                label="Blockchain"
                icon="box3"
                iconColor="grey_1"
                seeMore={selectedItem ? () => setOpen(true) : undefined}
              />
            </Box>
            <Box flex={1}>
              <HeaderInformationItem
                label="Processo Produtivo"
                value={getOrderProductionStatusText(
                  selectedItem?.orderProductionStatus,
                )}
                icon="swap2"
                iconColor="secondary"
                url={
                  selectedItem?.orderProductionCode
                    ? `/order-productions/${selectedItem?.orderProductionCode}`
                    : undefined
                }
              />
            </Box>
          </Box>
        </Styles.HeaderContainer>

        <Box width="100%" flex={1}>
          <ProductItemTraceability itemId={selectedItem?.id} />
        </Box>
      </Box>
      <BlockchainTreeModal
        open={open}
        setOpen={setOpen}
        data={itemBlockchainTree}
        linkUrlExplorer={blockchainNetwork?.urlExplorer}
        authInfo={encodeURIComponent(
          JSON.stringify(blockchainNetwork?.explorerLogin),
        )}
      />
    </>
  )
}
